<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article class="main">
    <header>
      <h2 class="nomargin">How many properties do you manage?</h2>
    </header>

    <section class="content">
      <p>To personalize your onboarding experience, please let us know how many properties you manage.</p>

      <form>
        <label>Number of properties</label>
        <mat-form-field fxFlex>
          <input
            matInput
            maxlength="4"
            [(ngModel)]="propertiesCount"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Please enter a number" />
        </mat-form-field>

        <button mat-flat-button [disabled]="!propertiesCount || saving" class="next-step" (click)="next()">
          <mat-spinner *ngIf="saving" [diameter]="30" class="button__spinner"></mat-spinner>
          Continue
        </button>
      </form>
    </section>
  </article>
  <aside>
    <div style="height: 563px; display: flex; align-items: flex-end; justify-content: center">
      <img
        [src]="
          propertiesCount > 9
            ? '/assets/images/signup/properties-large.svg'
            : '/assets/images/signup/properties-small.svg'
        " />
    </div>
  </aside>
</section>
